import { InsightMetric } from '@repo/types';
import { Expander } from '@repo/ui';
import c from 'classnames';
import { Button, EvidenceRating, Markdown, Typography } from 'components';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import styles from './SubMetricData.module.css';

type Props = {
  metric: InsightMetric;
  // Called when the section is expanded (not on collapse).
  onExpand?: () => void;
};

export default function AboutSection({ metric, onExpand }: Props) {
  const { trackEvent } = useAnalytics();

  return (
    <Expander
      containerClassName={styles.expanderContainer}
      trigger={(val, set) => (
        <Button
          color='purple'
          variant='text'
          onClick={() => {
            if (!val) {
              trackEvent('Learn More Clicked', {
                metric_name: metric?.name,
              });
              onExpand?.();
            }
            set(p => !p);
          }}
          iconNameRight={val ? 'chevronUp' : 'chevronDown'}
          label={val ? 'Show less' : 'Learn more'}
        />
      )}
    >
      <Typography variant='heading-m'>About</Typography>
      {metric?.evidence && <EvidenceRating evidenceRating={metric.evidence} />}
      <div className={c(styles.detailAbout, metric?.evidence && 'mt-2')}>
        <Markdown>{metric?.about ?? ''}</Markdown>
      </div>
    </Expander>
  );
}
